import { render } from "./TheRoleWorkspace.vue?vue&type=template&id=1c9437be"
import script from "./TheRoleWorkspace.vue?vue&type=script&lang=js"
export * from "./TheRoleWorkspace.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__